// extracted by mini-css-extract-plugin
export default {"collapsible_sign":"_36UBVKPE3EIA5GLUWBL0pk","collapsible_sign_expanded":"_1R62vSLmsNrdx_uORo1Uz"};